import { FC, memo, ReactElement } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { useGetAllSearchConsoleSitemapDomainsQuery } from '@/modules/Domains';

import { SearchConsoleSitemapListView } from './SearchConsoleSitemapListView';

interface Props {
  siteId: string;
}

export const SearchConsoleSitemapListContainer: FC<Props> = memo(({ siteId }) => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const {
    data: sitemapDomainsData,
    error: sitemapDomainsError,
    isLoading: isSitemapDomainsLoading,
    isFetching: isSitemapDomainsFetching,
    isError: isSitemapDomainsError
  } = useGetAllSearchConsoleSitemapDomainsQuery(siteId, { page: currentPage })({
    enabled: !!siteId
  });

  return (
    <FallbackedLayout
      isLoading={ isSitemapDomainsLoading }
      error={ sitemapDomainsError }
      isError={ isSitemapDomainsError }
      data={ sitemapDomainsData }
    >
      { (sitemapDomainsList): ReactElement => (
        <SearchConsoleSitemapListView
          currentPage={ currentPage }
          sitemapDomainsItems={ sitemapDomainsList.items }
          sitemapDomainsTotalItems={ sitemapDomainsList.meta.totalItems }
          sitemapDomainsItemsPerPage={ sitemapDomainsList.meta.itemsPerPage }
          isLoading={ isSitemapDomainsFetching }
          handleChangePage={ handleChangePage }
        />
      ) }
    </FallbackedLayout>
  );
});
